<template>
  <v-container>
    <v-card id="invoice-details">
<!--      <v-breadcrumbs :items="quote.versions">
         <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        :href="item"
      >
        {{ item.toUpperCase() }}
      </v-breadcrumbs-item>
      </template>
      </v-breadcrumbs>
-->
      <v-card-title> Στοιχεία Παραστατικού </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          :valid="valid"
        >
        <v-row v-if="invoice.Supplier">
          <v-col cols=12 sm=8 md=12>
          <v-text-field
          label="Προμηθευτής"
          v-model="invoice.Supplier.Name"
          prepend-icon="mdi-account"
            >
            <template v-slot:append>
              <v-btn icon @click="accountPage"><v-icon>mdi-information</v-icon></v-btn>
            </template>
          </v-text-field>
          </v-col>
          <v-col cols=8 sm=8 md=8>
          <v-text-field
          label="Διεύθυνση"
          v-model="invoice.Supplier.Address"
          prepend-icon="mdi-home"
            >
          </v-text-field>
          </v-col>
          <v-col cols=4 sm=4 md=4>
          <v-text-field
          label="Τηλέφωνο"
          v-model="invoice.Supplier.Telephone"
          prepend-icon="mdi-phone"
            >
          </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols=2 sm=2 md=2>
          <v-text-field
          label="Κωδικός Τιμολογίου"
          v-model="invoice.Id"
          prepend-icon="mdi-counter"
            >
          </v-text-field>
          </v-col>
            <v-col cols=2 sm=2 md=2>
          <v-text-field
          label="Σειρά Τιμολογίου"
          v-model="invoice.SeriesCode"
            >
          </v-text-field>
          </v-col>
           <v-col cols=2 sm=2 md=2>
          <v-text-field
          label="Αρ. Τιμολογίου"
          v-model="invoice.DocNumber"
          prepend-icon="mdi-counter"
            >
          </v-text-field>
          </v-col>
          <v-col cols=12 sm=4 md=3>
                <v-text-field
                  v-model="invoice.Date"
                  label="Ημερομηνία"
                  prepend-icon="mdi-calendar"
                  readonly
                ></v-text-field>
          </v-col>
          <v-col cols=3 sm=4 md=3>
            <v-select
              v-model="invoice.Kind"
              :items="invoiceKindOptions"
              label="Είδος Τιμολογίου"
              item-value="value"
              item-text="text"
            ></v-select> 
          </v-col>
        </v-row>
          <v-row>
          <v-col cols=12 md=6>
          <v-textarea
            v-model="invoice.Remarks"
            prepend-icon="mdi-notebook"
            rows="1"
            :auto-grow=true
            label="Σημειώσεις"
            hint="Αριθμός πλαισίου, όχημα, κλπ"
            >
         </v-textarea>
          </v-col>
          </v-row>
          <v-row>
          <v-btn
            v-if="invoice.InvoiceId"
            v-model="invoice.InvoiceId"
            outline
            dark
            color="primary"
            class="ml-2 white--text"
            :to="{name: 'Invoice', params: {invoid: invoice.InvoiceId}}"
            >
            <v-icon>mdi-file-document</v-icon>Τιμολογιο
          </v-btn>
          </v-row>
        </v-form>

      </v-card-text>
      <v-card-actions>
      <v-speed-dial
      v-model="fab"
      top
      right
      direction="left"
      absolute
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="blue darken-2"
          dark
          fab
        >
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
            <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="updateNotes">
              <v-icon dark>mdi-content-save</v-icon>
            </v-btn>
             <v-btn
              color="primary"
              fab
              class="ml-2 white--text"
              @click="getPDF"
              >
              <v-icon dark>mdi-file-pdf-box</v-icon>
            </v-btn>
            <v-btn
              fab
              color="primary"
              @click="fetchLabels(invoiceItems)"
              class="ml-2 white--text">
              <v-icon dark>mdi-sticker-outline</v-icon>
            </v-btn>
             <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="fetchInvoiceInfo">
              <v-icon dark>mdi-file-swap</v-icon>
            </v-btn>
            <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="patchInvoice">
              <v-icon dark>mdi-printer-pos</v-icon>
            </v-btn>
        </v-speed-dial>
      </v-card-actions>
    </v-card>
        <v-dialog v-model="showPrintDialog" max-width="800">
          <v-card>
            <v-card-title>
              <span class="text-h5">Προεπισκόπηση ετικετών</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
              <v-select
                v-model="labelType"
                :items="labelTypes"
                label="Στυλ ετικέτας"
                outlined
                dense
              ></v-select>
              <v-select
                v-model="labelRotate"
                :items="['auto', '0', '90']"
                label=""
                outlined
                dense
              ></v-select>
                </v-row>
                <v-row>
                  <v-col
                    v-for="(item, index) in labelItems"
                    :key="index"
                    cols="12"
                    sm="8"
                    md="6"
                  >
                    <v-card>
                      <v-img
                        :src="item.labelUrl"
                        alt="Label Preview"
                        contain
                        max-height="450"
                      ></v-img>
                      <v-card-actions>
                        <v-spacer/>
                         <v-text-field
                            v-model="item.quantity"
                            type="number"
                            min="1"
                            :max="item.StockQty"
                            hide-details
                            dense
                          ></v-text-field>
                        <v-btn
                          text
                          color="green darken-1"
                          @click="printLabel(item)"
                          :disabled="!isPrintServerHealthy"
                        >
                          Print
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="grey darken-1"
                @click="cancel"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
                v-model="printDialog"
                persistent
                max-width="600px"
              >
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Εκτύπωση ετικέτας</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="label">
                    <v-container>
                      <v-row>
                      <v-col cols="4" sm="4" md=4>
                          <v-text-field
                            label="Χρησιμοποιημένες*"
                            v-model.number="usedLabelQty"
                            type="number"
                            ></v-text-field>

                      </v-col>
                      </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="printDialog = false"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      :disabled="pdialog"
                      :loading="pdialog"
                      @click="printLabels"
                    > Εκτύπωση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog
              v-model="pdialog"
              hide-overlay
              persistent
              width="300"
            >
              <v-card
              >
                <v-card-text>
                Δημιουργία ετικετών, παρακαλώ περιμένετε.
                  <v-progress-linear
                    indeterminate
                    color="primary"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
      </v-card>
                    </v-dialog>
    <v-card class="mx-auto mt-10" id="item-list" >
      <v-card-title>Γραμμές Παραστατικού</v-card-title>
      <v-card-text>
      <v-data-table
        :headers="showHeaders"
        :items="invoiceItems"
        item-key="itemId"
        :search="search"
        :item-class="rowClass"
        class="elevation-0"
        height="600px"
        mobile-breakpoint=800
        dense
        fixed-header>

        <v-divider inset></v-divider>
        <template v-slot:top>
          <v-toolbar flat height="120px" color="white">
            <div class="d-flex w-200">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" dense outlined single-line hide-details></v-text-field>
            <v-dialog
                v-model="dialog"
                persistent
                max-width="600px"
              >
                <template v-slot:activator="{on, attrs}">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2 white--text">
                      <v-icon dark>mdi-plus</v-icon>Ανταλλακτικο
                    </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                    <v-btn icon @click="dialogOrders = true"><v-icon>mdi-history</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="invoice">
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            label="Κωδικός Προμηθευτή"
                            :rules="[rules.required]"
                            v-model="editedItem.SupplierSku"

                            >
                             <template v-slot:append>
                             <v-btn @click="copySku" icon><v-icon>mdi-content-copy</v-icon></v-btn>
                            </template>
                            </v-text-field>
                        </v-col>
                        <v-col
                          cols="6"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            label="Κωδικός Κατασκευαστή"
                            :rules="[rules.required]"
                            v-model="editedItem.ManufacturerSku"
                          >
                            <template v-slot:append>
                              <v-btn @click="searchAndUpdateManufacturer" icon>
                                <v-icon>mdi-magnify</v-icon>
                              </v-btn>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="6"
                          sm="6"
                          md="4"
                        >
                          <v-combobox
                            label="Κατασκευαστής"
                            :rules="[rules.required]"
                            :items="manufacturers"
                            v-model="editedItem.Manufacturer"

                            ></v-combobox>
                        </v-col>
                      <v-col cols="4" sm="4" md=4>
                          <v-text-field
                            label="Ποσότητα*"
                            :rules="[rules.required]"
                            v-model="editedItem.Qty"

                            required
                            ></v-text-field>

                      </v-col>
                      <v-col cols="4" sm="4" md=4>
                          <v-text-field
                            label="Αποθήκη*"
                            :rules="[rules.required]"
                            v-model="editedItem.StockQty"
                            dense
                            required
                            ></v-text-field>

                      </v-col>
                      <v-col cols="12" sm="12" md=12>
                      <v-autocomplete
                        v-model="editedItem.PartId"
                        :loading="isLoading"
                        :items="parts"
                        :search-input.sync="searchParts"
                        hide-details
                        placeholder="Αναζήτηση με # για SKU, @ για αντιστοιχίες. * για wildcard."
                        item-text='Description'
                        item-value='Id'
                        no-filter
                        :hint="`${select.FmSku} ${select.Id}`"
                        persistent-hint
                        label="Ανταλλακτικό"
                      >
                      <template v-slot:selection="data">
                        {{ data.item.Id }}: {{ data.item.FmSku }} - {{ data.item.Description }}
                      </template>
                      <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-item-content v-text="data.item"></v-list-item-content>
                        </template>
                        <template v-else>
                          <v-list-item-content>
                            <v-list-item-title v-html="data.item.FmSku"></v-list-item-title>
                            <v-list-item-subtitle v-html="data.item.Description"></v-list-item-subtitle>
                            <v-list-item-subtitle v-html="data.item.matchReason"></v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </template>
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              Δεν βρέθηκαν αποτελέσματα. Δοκιμάστε:
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <v-btn text @click="prependPrefix('#')"># για SKU</v-btn>
                              <v-btn text @click="prependPrefix('@')">@ για αντιστοιχίες</v-btn>
                              <v-btn text @click="prependPrefix('!')">! για Order ID</v-btn>
                              <v-btn icon @click="clearOrder(0)"><v-icon>mdi-trash-can</v-icon></v-btn>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </template>

                    </v-autocomplete>
                    </v-col>
                    <v-col cols="6" sm="6" md=4>
                        <v-text-field
                          label="Τιμή*"
                          :rules="[rules.required]"
                          v-model.number="editedItem.RetailPrice"
                          type="number"
                          dense
                          required
                          persistent-hint
                          :hint="`Net: ${netPrice}`"
                        >
                        <template v-slot:append v-if="showDivideButton">
                            <v-btn icon @click="divideRetailPriceByQty">
                              <v-icon>mdi-division</v-icon>
                              </v-btn>
                      </template>
                      </v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md=4>
                        <v-text-field
                          label="Εκπτωση*"
                          :rules="[rules.required]"
                          v-model.number="editedItem.Discount"
                          suffix="%"
                          dense
                          type="number"
                          required
                        ></v-text-field>
                    </v-col>

                    <v-col   cols="6" sm="6" md=4>
                        <v-text-field
                          label="Περιθώριο Κέρδους*"
                          :rules="[rules.required]"
                          v-if="isAdmin"
                          v-model.number="editedItem.Margin"
                          type="number"
                          suffix="%"
                          dense
                          required
                          :hint="`MU: ${markupPcnt.toFixed(2)}% / ${marginEur}`"
                          persistent-hint
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md=4>
                      <v-text-field
                        label="Λιανική"
                        v-if="isAdmin"
                        v-model.number="suggestedPrice"
                        dense
                        suffix="€"
                        read-only
                        > 
                        <template v-slot:append>
                          <v-btn size="x-small" icon @click="roundSuggestedPrice" :title="'Στρογγυλοποίηση στη πλησιέστερη τιμή'">
                            <v-icon>mdi-decimal</v-icon>
                          </v-btn>
                          <v-btn size="x-small" icon @click="ceilSuggestedPrice" :title="'Στρογγυλοποίηση στη πλησιέστερη τιμή'">
                            <v-icon>mdi-decimal-decrease</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md=4>
                    <v-select
                        label="Μονάδα Μέτρησης"
                        v-model="editedItem.Unit"
                        :items="['ΤΕΜ', 'ΣΕΤ', 'ΚΙΛΑ', 'ΚΥΒΙΚΑ', 'ΛΙΤΡΑ', 'ΜΕΤΡΑ', '']"
                        dense
                        single-line>
                      </v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md=4>
                          <v-select
                            label="Κατάσταση"
                            :rules="[rules.required]"
                            v-model="editedItem.Status"
                            :items="statuses"
                            dense single-line
                            required
                            ></v-select>
                      </v-col>
                      <v-col cols="6" sm="6" md=4>
                          <v-select
                            label="Τεχνικός"
                            :rules="[rules.required]"
                            v-model="editedItem.TechId"
                            :items="technicians"
                            item-text="Name"
                            item-value="Id"
                            dense single-line
                            required
                            ></v-select>
                      </v-col>
                      </v-row>
                      <v-row>
                      <v-col cols=12 md=12>
                      <v-textarea
                        v-model="editedItem.Remarks"
                        prepend-icon="mdi-notebook"
                        rows="1"
                        :auto-grow=true
                        label="Σημειώσεις"
                        hint="Αριθμός πλαισίου, όχημα, κλπ"
                        >

                     </v-textarea>
                     </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" sm="6" md="4">
                        <v-select
                          v-model="editedItem.LocationPart"
                          :items="['RU', 'SU1', 'SU2', 'SU3', 'CU1', 'CU2', 'OU']"
                          label="Location"
                          dense
                          required
                        ></v-select>
                      </v-col>
                       <v-col cols="6" sm="6" md="4">
                        <v-autocomplete
                          v-model="editedItem.ShelfPosition"
                          :items="shelfPositionOptions"
                          label="Shelf Position"
                          dense
                          required
                          :rules="[rules.shelfPositionRule]"
                          hide-details
                          :filter="customFilterShelf"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="6" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.ShelfPosition"
                          :prefix="`${editedItem.LocationPart}-`"
                          label="Shelf Position"
                          dense
                          required
                          :rules="[rules.shelfPositionRule]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="close"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                    >
                      Αποθήκευση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

            </div>
                 <v-file-input
                  chips
                   dense
                  prepend-icon="mdi-microsoft-excel"
                  accept=".csv,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  label="Αρχείο γραμμών"
                  placeholder="Επιλέξτε αρχείο ανταλλακτικών"
                  v-model="partsFile"
                >
                <template v-slot:append>
                <v-btn @click="updateParts" icon><v-icon>mdi-update</v-icon></v-btn>
			</template></v-file-input>
              <v-spacer/>

               <v-dialog
                v-model="ecosDialog"
                persistent
                max-width="800px"
              >
                <template v-slot:activator="{on, attrs}">
                  <v-btn
                    @click="ecosDialog = true"
                    icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2 white--text">
                        <v-icon>mdi-qrcode-scan</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Scan Barcode</span>
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      ref="barcodeInput"
                      label="Enter Barcode URL"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="ecosDialog = false">
                      Close
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="processBarcode">
                      Check
                    </v-btn> </v-card-actions>
                </v-card>
              </v-dialog>
              <v-spacer/>
               <v-dialog
                v-model="dialogCheckout"
                persistent
                max-width="800px"
              >
                <template v-slot:activator="{on, attrs}">
                    <v-btn
                      :disabled="chargeDis"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2 white--text">
                      <v-icon>mdi-human-dolly</v-icon>Χρεωση
                    </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Χρέωση</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="checkout">
                    <v-container>
                      <v-row>
                       <v-col cols="12" sm="8" md=6>
    <v-autocomplete
      v-model="repair"
      :items="repairs"
      cache-items
      hide-no-data
      hide-details
      item-text='Vehicle.PlateNumber'
      return-object
      persistent-hint
      label="Επισκευή"
      :filter="customRepairFilter"
    >
    <template v-slot:selection="data">
                  {{ data.item.Vehicle.PlateNumber }} - {{ data.item.Date }}
              </template>
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.Vehicle.PlateNumber"></v-list-item-title>
                    <v-list-item-subtitle v-html="data.item.Vehicle.Owner.Name"></v-list-item-subtitle>
                    <v-list-item-subtitle v-html="data.item.Date"></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>


    </v-autocomplete>
    </v-col>
                      <v-col cols="6" sm="6" md=4>
                          <v-select
                            label="Τεχνικός"
                            :rules="[rules.required]"
                            v-model="partTechId"
                            :items="technicians"
                            item-text="Name"
                            item-value="Id"
                            dense single-line
                            required
                            ></v-select>
                      </v-col>
                      </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      :disabled="!chargeDis"
                      color="blue darken-1"
                      text
                      :to="{name: 'edit-repair', params: {repairId: repair.Id}}"
                      >
                      Μετάβαση στην επισκευή
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialogCheckout = false"
                    >
                      Κλείσιμο
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="bulkCheckout"
                    >
                      Αποθήκευση
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-spacer/>

                   <v-btn
                       color="primary"
                       @click="selfUse"
                    >
                      <v-icon>mdi-basket</v-icon>
                      Ιδιοκαταναλωση
                    </v-btn>
            <v-spacer/>

        <div class="text-right py-10 ma-5">
          <p><b>Σύνολο:</b>&nbsp;  <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        >{{ tocurr(net) }}</span>
      </template>
      <span>Ανταλλακτικά: {{ tocurr(netItems) }} </span>
    </v-tooltip></p>
          <p><b>ΦΠΑ 24%:</b>&nbsp; {{ tocurr(vat) }}</p>
          <p><b>Γενικό Σύνολο:</b>&nbsp; {{ tocurr(total) }}</p>
        </div>
            </v-toolbar>
          </template>

        <template v-slot:item.index="{ item }">
          <span>{{invoiceItems.indexOf(item)+1}}</span>
        </template>
        <template v-slot:item.Description="{ item }">
          <v-btn icon @click="$router.push({name: 'part-info', params: {id: item.PartId}})">
            <v-icon>mdi-package-variant</v-icon>
          </v-btn>
          <span v-if="item.FmSku=='69.09999'">{{ item.Remarks }}</span>
          <span v-else>{{ item.Description }}</span>
        </template>
        <template v-slot:item.Status="{ item }">
          <span>{{ getStatus(item.Status) }}</span>
        </template>
         <template v-slot:item.TechId="{ item }">
          <span>{{ technicians[item.TechId-1].Name }}</span>
        </template>
        <template v-slot:item.vat="{ item }">
          <span v-if="isNaN(item.RetailPrice)"></span>
            <span v-else>{{ tocurr(item.Qty*item.RetailPrice*0.24)}}</span>
        </template>
         <template v-slot:item.RetailPrice="{ item }">
          <span v-if="isNaN(item.RetailPrice)"></span>
            <span v-else>{{ tocurr(item.RetailPrice)}}</span>
        </template>
         <template v-slot:item.NetValue="{ item }">
          <span v-if="isNaN(item.RetailPrice)"></span>
            <span v-else>{{ tocurr((1- item.Discount/100)*item.RetailPrice)}}</span>
        </template>
         <template v-slot:item.Discount="{ item }">
            {{ item.Discount}}
        </template>
        <template v-slot:item.gross="{ item }">
          <span v-if="isNaN(item.RetailPrice)"></span>
            <span v-else>{{ tocurr(item.Qty*((1-item.Discount/100)*item.RetailPrice).toFixed(2))}}</span>
        </template>
        <template v-slot:item.value="{ item }">
          <span v-if="isNaN(item.RetailPrice)"></span>
            <span v-else>{{ tocurr(item.Qty*((1-item.Discount/100)*item.RetailPrice).toFixed(2)*1.24)}}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div>
            <v-icon class="mr-3" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon class="mr-3" @click="copyItem(item)">
              mdi-content-copy
            </v-icon>
            <v-icon class="mr-3" @click="deleteItem(item)">
              mdi-delete
            </v-icon>
            <v-icon class="mr-3" @click="openPreorderCorrelate(item)">
              mdi-link-variant
            </v-icon>
            <v-btn
              icon
              :to="{name: 'order-info', params: {id: item.Id}}"
                >
            <v-icon>mdi-warehouse</v-icon>
        </v-btn>
          </div>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="dialogOrders"
      width="auto"
    >
      <v-card>
       <v-card-title> Προηγούμενες παρτίδες </v-card-title>
        <v-card-text>
        <v-text-field v-model="searchOrders" append-icon="mdi-magnify" label="Search" dense single-line clearable hide-details></v-text-field>
        <v-container>
           <v-data-table
        :headers="ordersHeaderD"
        :loading="isLoading"
        :items="orders"
        :search="searchOrders"
        :item-class="rowClass"
        class="elevation-0"
        height="400px"
        sort-by="Timestamp"
        sort-desc
        mobile-breakpoint=800
        :items-per-page=15
        fixed-header>
         <template v-slot:item.Timestamp="{ item }">
       {{  new Date(item.Timestamp).toLocaleDateString()  }}
    </template>

    <template v-slot:item.actions="{ item }">
             <v-btn
              class="mr-2"
              icon
              small
              @click.stop="copyOrder(item)"
            >
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
                </template>
        </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="dialogOrders = false">Κλεισιμο</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="preorderCorrelateDialog"
      max-width="900px"
    >
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon class="mr-2">mdi-link-variant</v-icon>
          Συσχέτιση με Προπαραγγελία
          <v-spacer></v-spacer>
          <v-chip v-if="preorderSourceItem" small>{{ (invoice.Supplier && invoice.Supplier.Name) || '—' }}</v-chip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div v-if="preorderCorrelateLoading" class="text-center py-6">
            <v-progress-circular indeterminate color="primary" />
          </div>
          <div v-else>
            <div v-if="preorderCorrelated && preorderCorrelated.length" class="mb-4">
              <div class="subtitle-2 mb-2">Ήδη συσχετισμένες προπαραγγελίες</div>
              <v-container fluid>
                <v-row>
                  <v-col v-for="po in preorderCorrelated" :key="'c-'+po.Id" cols="12" sm="6" md="4">
                    <v-card elevation="1" class="grey lighten-4">
                      <v-card-title class="justify-space-between">
                        #{{ po.Id }}
                        <v-chip x-small :color="preorderStatusColor(po.Status)" dark>{{ getPreorderStatus(po.Status) }}</v-chip>
                      </v-card-title>
                      <v-card-subtitle>
                        {{ po.Timestamp ? new Date(po.Timestamp).toLocaleDateString() : '-' }}
                      </v-card-subtitle>
                      <v-card-text>
                        <div class="text-body-2 mb-1">{{ (po.PartInfo && po.PartInfo.Description) || po.Description || '-' }}</div>
                        <div class="caption grey--text">
                          {{ po.SupplierSku || '' }}<span v-if="po.SupplierSku && po.ManufacturerSku"> • </span>{{ po.ManufacturerSku || '' }}
                        </div>
                        <div class="caption grey--text">Ποσ: {{ po.Qty }} {{ po.Unit }} • {{ tocurr(po.Price || 0) }}</div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-divider class="my-2" />
            </div>

            <div v-if="!preorderCandidates || preorderCandidates.length === 0" class="text-center grey--text">
              Δεν βρέθηκαν διαθέσιμες προπαραγγελίες για συσχέτιση.
            </div>
            <v-container v-else fluid>
              <div class="subtitle-2 mb-2">Διαθέσιμες προπαραγγελίες</div>
              <v-row>
                <v-col v-for="po in preorderCandidates" :key="po.Id" cols="12" sm="6" md="4">
                  <v-card :elevation="preorderSelectedId === po.Id ? 8 : 2" :class="{'primary--text': preorderSelectedId === po.Id}" class="hoverable" @click="preorderSelectedId = po.Id">
                    <v-card-title class="justify-space-between">
                      #{{ po.Id }}
                      <v-chip x-small :color="preorderStatusColor(po.Status)" dark>{{ getPreorderStatus(po.Status) }}</v-chip>
                    </v-card-title>
                    <v-card-subtitle>
                      {{ po.Timestamp ? new Date(po.Timestamp).toLocaleDateString() : '-' }}
                    </v-card-subtitle>
                    <v-card-text>
                      <div class="text-body-2 mb-1">{{ (po.PartInfo && po.PartInfo.Description) || po.Description || '-' }}</div>
                      <div class="caption grey--text">
                        {{ po.SupplierSku || '' }}
                        <span v-if="po.SupplierSku && po.ManufacturerSku"> • </span>
                        {{ po.ManufacturerSku || '' }}
                      </div>
                      <div class="caption grey--text">
                        Ποσ: {{ po.Qty }} {{ po.Unit }} • {{ tocurr(po.Price || 0) }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="preorderCorrelateDialog = false">Κλείσιμο</v-btn>
          <v-btn color="primary" :disabled="!preorderSelectedId" @click="savePreorderCorrelation">Αποθήκευση</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
//const _ = require("lodash");
//import {some as _some} from "lodash";

export default {
  props: {
    //invoiceItems: []
  },
  computed: {
    net () {
      return this.sumTotals(this.invoiceItems);
    },
    netItems () {
      return this.sumTotals(this.invoiceItems);
    },
    netService () {
      return this.sumTotals(this.invoiceItems.filter(e=>e.Status !=-1));
    },
    vat () {
      return Number(this.net) * 0.24;
    },
    total () {
      return Number(this.net) + Number(this.vat);
    },
    pdfPath () {
        return `${this.$api.defaults.baseURL}/invoice/${this.invoice.Id}/card/`;
    },
    markupPcnt () {
        return (this.editedItem.Margin / (1-this.editedItem.Margin/100))
    },
    marginEur () {
        return this.$tocurr((this.editedItem.RetailPrice * (1-this.editedItem.Discount/100)  *( 1 / (1-this.editedItem.Margin/100) - 1)))
    },
    suggestedPrice () {
        return (this.editedItem.RetailPrice * (1-this.editedItem.Discount/100) / (1 - this.editedItem.Margin/100)).toFixed(2)
    },
    netPrice () {
        return (this.editedItem.RetailPrice * (1-this.editedItem.Discount/100)).toFixed(2)
    },
    showHeaders() {
        if (this.$vuetify.breakpoint.smAndDown) {
            return this.headers.filter(h => !(["vat", "Status", "value", "TechId"]).includes(h.value));
        } else {
            return this.headers;
        }
    },
    manufacturers() {
      return this.$manufacturers.map(e=>e.title);
    },
    formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
    isAdmin() {
        //return false;
        if (!this.$store.state.authentication.user) return false;
        return this.$store.state.authentication.user.scopes.includes("income");
    },
    ordersHeaderD() {
        let income = this.$store.state.authentication.user.scopes.includes("income");
        if (income) return this.ordersHeader;
        return this.ordersHeader.filter(h => h.value != 'SuggestedPrice');
    },
    showDivideButton() {
      const allowedUnits = ['ΚΙΛΑ', 'ΛΙΤΡΑ', 'ΜΕΤΡΑ', 'ΚΥΒΙΚΑ'];
      return allowedUnits.includes(this.editedItem.Unit);
    },


  },
   watch: {
      asearchParts (val) {
        // val && val !== this.select && this.queryParts(val)
        val && val !== this.select
      },
      searchParts(val) {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
        this.fetchFilteredParts(val);
        }, 300); // Adjust the delay as needed
      },
      labelType() {
        this.fetchLabels(this.invoiceItems);
      },
    },
  async mounted() {
      // Fetch labelTypes
      const resp = await this.$api.get('/inventory/order-label-types');
      this.labelTypes = resp.data;
  },
  data () {
    return {
    menu: false,
    fab: false,
    valid: true,
    chargeDis: false,
    dialog: false,
    dialogOrders: false,
    dialogCheckout: false,
    pdialog: false,
    invoice: {},
    technicians: {},
    partTechId: 1,
    isLoading: false,
    select: '',
    printDialog: false,
    usedLabelQty: 0,
    searchParts: '',
    parts: [],
    allParts: [],
    orders: [],
    repairs: [],
    repair: {Id: 0},
    searchOrders: '',
    partsFile: null,
    showPrintDialog: false,
    barcodeUrl: '',
    ecosDialog: false,
    preorderCorrelateDialog: false,
    preorderCorrelateLoading: false,
    preorderCandidates: [],
    preorderCorrelated: [],
    preorderSelectedId: null,
    preorderSourceItem: null,
    labelItems: [],
    labelRotate: 'auto',
    labelType: '29x48-4',
    labelTypes: [],
    ecosHostnames: ['einvoice.s1ecos.gr', 'einvoice.impact.gr', 'einvoiceapi.impact.gr'],
    epsilonHostnames: ['beta-epsilondigital.epsilonnet.gr', 'epsilondigitalsmart.epsilonnet.gr', 'epsilondigital3.epsilonet.gr', 'epsilondigital3.epsilonnet.gr'],
    pegasusHostnames: ['e-invoicing.pegcloud.io'],
    entersoftHostnames: ['e-invoicing.gr'],
    isPrintServerHealthy: false,
    rules: {
        required: value => !!value || 'Required.',
        shelfPositionRule: value => {
          const pattern = /^[1-6][GRA-E]-[0-1][0-9]$/;
          return pattern.test(value) || 'Invalid shelf position format';
        },
    },
    shelfPositionOptions: this.generateShelfPositions(),
    debounceTimeout: null,
    search: '',
    searchPart: '',
    invoiceKindOptions: [
      { value: 0, text: 'Ανταλλακτικά' },
      { value: 1, text: 'Αναλώσιμα' },
      { value: 2, text: 'Βενζίνη' },
      { value: 3, text: 'Τρόφιμα' },
      { value: 4, text: 'Εργαλεία' },
    ],
    headers: [
      {
        text: 'A/A',
        value: 'index',
        sortable: false,
        width: '5%'
      },
      {
        text: 'Κωδικός',
        value: 'SupplierSku',
        sortable: false,
        width: '10%'
      },
      {
        text: 'Κωδικός Προμ.',
        value: 'ManufacturerSku',
        sortable: false,
        width: '10%'
      },
      {
        text: 'Περιγραφή',
        value: 'Description',
        sortable: false,
        width: '45%'
      },
      {
        text: 'Ποσότητα',
        value: 'Qty',
        sortable: false,
        width: '5%'
      },
      {
        text: 'Μονάδα',
        value: 'Unit',
        sortable: false,
        width: '5%'
      },
      {
        text: 'Τιμή',
        value: 'RetailPrice',
        sortable: false,
        width: '5%'
      },
       {
        text: 'Αξια μον.',
        value: 'NetValue',
        sortable: false,
        width: '5%'
      },
       {
        text: 'Εκπτωση %',
        value: 'Discount',
        sortable: false,
        width: '5%'
      },
      {
        text: 'Καθ. Αξία',
        value: 'gross',
        sortable: false,
        width: '5%'
      },
      {
        text: 'ΦΠΑ',
        value: 'vat',
        sortable: false
      },
      {
        text: 'Αξία',
        value: 'value',
        sortable: false
      },
      {
        text: 'Κατάσταση',
        value: 'Status',
        sortable: false
      },
      {
        text: 'Τεχνικός',
        value: 'TechId',
        sortable: false
      },
      { text: 'Actions', value: 'actions', sortable: false , width: "180px"},
    ],
    ordersHeader: [
       {
            text: 'Α/Α',
            align: 'start',
            //sortable: false,
            value: 'Id',
            width: '5%',
          },
           { text: 'Ημ/νια', value: 'Timestamp', align: 'start' },
          {
            text: 'Κωδικός',
            align: 'start',
            //sortable: false,
            value: 'PartInfo.FmSku',
            width: '5%',
          },
           {
            text: 'Id',
            align: 'start',
            //sortable: false,
            value: 'PartInfo.Id',
            width: '5%',
          },
          {
            text: 'Κωδικός Προμηθευτή',
            align: 'start',
            //sortable: false,
            value: 'SupplierSku',

            width: '5%',
          },
          {
            text: 'Κωδικός Κατασκευαστή',
            align: 'start',
            //sortable: false,
            value: 'ManufacturerSku',

            width: '5%',
          },
         { text: 'Κατασκευαστής', value: 'Manufacturer', groupable: true, width: '20%',
          },
          { text: 'Περιγραφή', value: 'PartInfo.Description', groupable: false, width: '50%'},

         { text: 'Τιμή χονδρικής', value: 'RetailPrice', align: 'end', groupable: false },
          { text: 'Τιμή λιανικής', value: 'SuggestedPrice', align: 'end', groupable: false },
          { text: 'Actions', value: 'actions', groupable: false, width: '25%' }
        ],

    invoiceItems: [],
    statuses: [
      {value: -2, text: "Χαλασμένο"},
      {value: -1, text: "Μεταχειρισμένο"},
      {value: 0, text: "Καινούργιο"},
      {value: 1, text: "Ανακατασευή"},
      {value: 2, text: "Επισκευασμένο"},
     ]
      ,
    editedIndex: -1,
    editedItem: {
      itemId: 0,
      Id: 0,
      PartId: 0,
      SupplierSku: '000-0000',
      ManufacturerSku: '000-0000',
      Manufacturer: '',
      Qty: 1,
      StockQty: 1,
      Unit: 'TEM',
      RetailPrice: 0,
      Discount: 0,
      Profit: 60,
      Margin: 40,
      Status: 0,
      Remarks: '',
      TechId: 5,
      LocationPart: 'RU',
      ShelfPosition: '1R-00',
    },
    defaultItem: {
      Id: 0,
      itemId: 0,
      PartId: 0,
      SupplierSku: '000-0000',
      ManufacturerSku: '000-0000',
      Manufacturer: '',
      Qty: 1,
      StockQty: 1,
      Unit: 'ΤΕΜ',
      RetailPrice: 0,
      Discount: 0,
      Margin: 40,
      Status: 0,
      Remarks: '',
      TechId: 5,
      LocationPart: 'RU',
      ShelfPosition: '1R-00',
    },
    }
  },
  async created () {
      this.initialize();
  },

  methods: {
  generateShelfPositions() {
      const positions = [];
      const sections = ['G', 'R', 'A', 'B', 'C', 'D', 'E'];
      for (let i = 1; i <= 6; i++) {
        for (const section of sections) {
          for (let j = 0; j <= 19; j++) {
            const position = `${i}${section}-${j.toString().padStart(2, '0')}`;
            positions.push(position);
          }
        }
      }
      return positions;
    },
  customFilterShelf(item, queryText, itemText) {
      const query = queryText.toLowerCase().replace(/[^a-z0-9]/gi, '');
      const text = itemText.toLowerCase().replace(/[^a-z0-9]/gi, '');

      // Check if the query is a substring of the item text
      if (text.includes(query)) {
        return true;
      }

      // Additional logic to handle specific cases
      const regex = new RegExp(query.split('').join('.*'), 'i');
      return regex.test(text);
  },
  accountPage() {
        let path = "distributor-invoices"
        let params = {"id": this.invoice.Supplier.Id}

        this.$router.push({"name": path, "params": params});
    },
    sumTotals(items) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + ((b.RetailPrice*(1-b.Discount/100)).toFixed(2)*b.Qty || 0), 0);
    },
    getStatus (status) {
      if (status == -2) return "Χαλασμένο";
      if (status == -1) return "Μεταχειρισμένο";
      if (status == 2) return "Επισκευασμένο";
      if (status == 1) return "Ανακατασκευή";
      if (status == 0) return "Καινούργιο";
    },
    duplicateQuote () {
      return
    },
    async updateNotes () {
        await this.$api.patch("/suppliers/invoice/"+this.$route.params.invoiceId, {Remarks: this.invoice.Remarks, Kind: this.invoice.Kind});
    },
    
    async patchInvoice () {
        const response = await this.$api.patch("/suppliers/invoice/"+this.$route.params.invoiceId);
        if (response.status == 202) {
              this.invoice = response.data;
              this.invoiceItems = [];
              let j = 1;
              for (var value of this.invoice.LineItems) {
                value.itemId = j;
                this.invoiceItems.push(value);
                j +=1;
              }
        }
    },
    async getPDF () {
        const response = await this.$api.get(`/suppliers/invoice/${this.invoice.Id}/card`);
        window.open(`${this.$api.defaults.baseURL}/invoice/card/${response.data}`, '_blank');
    },
   async printLabels() {
         this.pdialog = true;

         const options = {
          method: 'GET',
          params: {start_from: this.usedLabelQty},
          url: '/suppliers/printlabels/'+this.invoice.Id,
          responseType: "blob",
         };


          const response = await this.$api(options)
          this.pdialog = false
          let url = window['URL'].createObjectURL(response.data)

          var a = document.createElement('a')
          a.href = url
          a.download = "labels.pdf";
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)

    },

    rowClass (item) {
      return item.StockQty == 0 ? 'blue-grey lighten-4' : 'white darken-2';
    },
    async initialize () {
      const response = await this.$api.get("/suppliers/invoice/" + this.$route.params.invoiceId, {cache: {maxAge: 30*1000}});
      this.invoice = response.data;
      let j = 1;
      for (var value of this.invoice.LineItems) {
        value.itemId = j;
        this.invoiceItems.push(value);
        j +=1;
      }

      const techs = await this.$api.get("/repairs/technicians/");
      this.technicians = techs.data;

      // console.log(this.quote);
      const resp = await this.$api.get("/inventory/items", {params: {limit: 4000}});

      this.allParts = resp.data;

      const orders_r = await this.$api.get(`/inventory/supplier/${this.invoice.Supplier.Id}/orders`);
      // const orders_r = await this.$api.get(`/inventory/orders2`);
      this.orders = orders_r.data;

      const rep = await this.$api.get("/repairs?limit=40");
      this.repairs = rep.data;

    },
    async fetchInvoiceInfo() {
      const response = await this.$api.get("/aade/supplier-invoice/info/" + this.invoice.Id);
      if (response.data) {
       this.invoice = response.data; 
        let j = 1;
        for (var value of this.invoice.LineItems) {
          value.itemId = j;
          this.invoiceItems.push(value);
          j +=1;
        }
      }
    },
    copyItem (item) {
      const addObj = Object.assign({}, item);
      addObj.itemId = this.invoiceItems.length + 1;
      this.invoiceItems.unshift(addObj);
    },
    editItem (item) {
      this.editedIndex = this.invoiceItems.indexOf(item);
      item.Margin = parseFloat((item.Profit / (100 + item.Profit) * 100).toFixed(2))
      // Split the Location into LocationPart and ShelfPosition
      const [locationPart, shelfPosition1, shelfPostion2] = item.Location.split('-');
      item.LocationPart = locationPart;
      item.ShelfPosition = shelfPosition1 + '-' + shelfPostion2;
      this.editedItem = Object.assign({}, item);
      this.parts = this.allParts.filter(part => part.Id == this.editedItem.PartId);
      this.dialog = true;
    },
    async deleteItem (item) {
      const index = this.invoiceItems.indexOf(item);
      if (confirm('Are you sure you want to delete this item?')) {
        if (item.Id) {
            const resp = await this.$api.delete("/inventory/parts/checkin/"+item.Id);
          if (resp.status == 200) {
            this.invoiceItems.splice(index, 1);
          } else {
            alert(resp.data.detail);
          }
        } else {
              this.invoiceItems.splice(index, 1);
          }

      }
    },
    async queryParts (v) {
        this.isLoading = true
          const resp = await this.$api.get("/inventory/parts/search/"+v);

          this.parts = resp.data;
            this.isLoading = false
      },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300)
    },
    addNew() {
       const addObj = Object.assign({}, this.defaultItem);
       addObj.itemId = this.invoiceItems.length + 1;
       this.invoiceItems.unshift(addObj);
       this.editItem(addObj);
    },
    async updateParts() {
      if (this.partsFile) {
        try {
          var formData = new FormData();
          formData.append("lines_file", this.partsFile);
          formData.append("invoice_id", this.invoice.Id);
          let resp = await this.$api.post("/inventory/parts/bulk-checkin", formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          if (resp.status == 201) {
            alert("Οι γραμμές του παραστατικού ενημερώθηκαν", resp.data.added);
          } else {
            alert("Σφάλμα ενημέρωσης");
            console.log(resp);
          }
          this.partsFile = null;
          // const response = await this.$api.get('/invoices/parts');
          //this.parts = response.data;
        } catch (error) {
          console.log(error);
        }
      }
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    copySku() {
        let sku = this.editedItem.SupplierSku;
        this.editedItem.ManufacturerSku = sku;
    },
   copyOrder(item) {
    this.parts = this.allParts.filter(part => part.Id == item.PartId);
    this.editedItem.SupplierSku = item.SupplierSku;
    this.editedItem.ManufacturerSku = item.ManufacturerSku;
    this.editedItem.Manufacturer = item.Manufacturer;
    this.editedItem.Margin = parseFloat((item.Profit/(item.Profit+1)*100).toFixed(2));
    this.editedItem.PartId = item.PartId;
    this.editedItem.Discount = item.Discount * 100;
    this.editedItem.RetailPrice = item.RetailPrice;
    this.editedItem.Unit = item.Unit;
    this.dialogOrders = false;
    this.searchOrders = '';
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.invoiceItems[this.editedIndex], this.editedItem);
        this.patchinvoiceItem(this.editedIndex);
      } else{
        this.invoiceItems.push(this.editedItem);
        this.patchinvoiceItem(-1);
      }
      this.close()
    },
    async bulkCheckout() {
        let checkout = {
              RepairId: this.repair.Id,
              InvoiceId: this.$route.params.invoiceId,
              TechId: this.partTechId,
        }
        const resp = await this.$api.post("/repairs/items/copy", checkout)
        if (resp.status == 201) {
            alert("Χρεώθηκε στο όχημα")
            this.chargeDis = true

            const response = await this.$api.get("/suppliers/invoice/" + this.$route.params.invoiceId, {cache: {maxAge: 30*1000}});
            this.invoice = response.data;
            this.invoiceItems = [];
            let j = 1;
            for (var value of this.invoice.LineItems) {
              value.itemId = j;
              this.invoiceItems.push(value);
              j +=1;
            }
          }
    // this.dialogCheckout = false
    },
    async selfUse() {
        let checkout = {
              RepairId: 1262,
              InvoiceId: this.$route.params.invoiceId,
              TechId: this.partTechId,
        }
        const resp = await this.$api.post("/repairs/items/copy", checkout)
          if (resp.status == 201) {
            alert("Χρεώθηκε στο μαγαζί")
            }
    },
    searchAndUpdateManufacturer() {
      if (this.editedItem.PartId) {
        // Find the part with the matching PartId
        const part = this.allParts.find(part => part.Id === this.editedItem.PartId);
        if (part && part.References) {
          // Check if References includes the ManufacturerSku
            let crossref = part.References.find(reference => reference.Sku.includes(this.editedItem.ManufacturerSku) && !reference.Manufacturer.includes('ARTNR'));
            if (crossref) {
            // Update Manufacturer and ManufacturerSku
            this.editedItem.Manufacturer = crossref.Manufacturer.toUpperCase() || '';
            // this.editedItem.ManufacturerSku = crossref.Sku;
          }
        }
      } else {
        // Iterate over all parts and check their References
        let crossref = null;
        for (const part of this.allParts) {
          if (part.References.some(ref => ref.Sku.includes(this.editedItem.ManufacturerSku))) {
            // Update Manufacturer and ManufacturerSku
            crossref = part.References.find(reference => reference.Sku.includes(this.editedItem.ManufacturerSku));
            if (crossref) {
              // Update Manufacturer and ManufacturerSku
              this.editedItem.Manufacturer = crossref.Manufacturer.toUpperCase() || '';
              this.editedItem.PartId = part.Id
              this.parts = part;
              // this.editedItem.ManufacturerSku = crossref.Sku;
              break; // Assuming you want to update with the first found reference
            }
          }
        }
      }
    },
    prependPrefix(prefix) {
      // Define the possible prefixes
      const prefixes = ['#', '!', '@', '$'];

      // Check if orderSearch is defined and not empty
      if (this.searchParts) {
        // Remove existing prefix if present
        const firstChar = this.searchParts.charAt(0);
        if (prefixes.includes(firstChar)) {
          this.searchParts = this.searchParts.substring(1);
        }
      }

      // Prepend the new prefix
      this.searchParts = prefix + (this.searchParts || '');
    },
    fetchFilteredParts(queryText) {
      if (queryText==null) return;

      this.isLoading = true;

      // Determine the search mode based on the prefix
      const isSkuSearch = queryText.startsWith('#');
      const isRefSearch = queryText.startsWith('@');
      const isIdSearch = queryText.startsWith('!');
      let searchText = '';
      if (isRefSearch || isSkuSearch || isIdSearch) {
        searchText = queryText.slice(1).toUpperCase(); // Remove prefix for actual search
      } else {
        searchText = queryText.toUpperCase(); // To uppercase for search
      }

      // Convert '*' to a regex pattern for fuzzy matching
      const searchPattern = new RegExp('^' + searchText.replace(/[^\p{L}\p{N}\\*]/gu, '').replace(/\*/g, '.*') + '.*$', 'i');
      const searchSkuPattern = new RegExp('^.*\\.' + searchText.replace(/\*/g, '.*') + '$', 'i');
      // Split the search text into individual terms
      const searchTerms = searchText.split(/\s+/);

      // Simulate fetching data with filtering
      this.parts = this.allParts.filter(item => {
        const desc = item.Description.toUpperCase();
        const skus = item.FmSku.toUpperCase();
        const refs = item.References;

        // Fuzzy search for description
        // const descMatches = desc.includes(searchText) || searchPattern.test(desc);
        // Fuzzy search for description
        const descMatches = searchTerms.every(term => desc.includes(term));

        // Search in FmSku
        const skuMatches = searchSkuPattern.test(skus);

        // Search in References

        // const refMatches = refs.some(o => o.Sku.replace(/[^\p{L}\p{N}]/gu, '').includes(searchText));
        //const refMatches = refs.some(o => searchPattern.test(o.Sku.toUpperCase()));

        // Apply search logic based on the prefix
        // if (isSkuSearch) {
        //   return skuMatches || skus.includes(searchText);
        // } else if (isRefSearch) {
        //   return refMatches;
        // } else {
        //   return descMatches //|| skuMatches || refMatches;
        // }


        let matchReason = '';
        if (isSkuSearch) {
          if (skuMatches || skus.includes(searchText)) {
            matchReason = `Matched by SKU: ${searchText}`;
            item.matchReason = matchReason;
            return true;
          }
        } else if (isRefSearch) {
          const refMatches = refs.some(o => searchPattern.test(o.Sku.replace(/[^\p{L}\p{N}]/gu, '')));
          if (refMatches) {
            const matchedRef = refs.find(o => searchPattern.test(o.Sku.replace(/[^\p{L}\p{N}]/gu, '')));
            matchReason = `Matched by Reference: ${matchedRef ? matchedRef.Sku : ''}`;
            item.matchReason = matchReason;
            return true;
          }
        } else if (isIdSearch) {
            if (item.Id == searchText) {
              matchReason = `Matched by Id: ${searchText}`
              item.matchReason = matchReason;
              return true;
            }
        } else {
          if (descMatches) {
            matchReason = `Matched by Description: ${searchTerms.join(' ')}`;
            item.matchReason = matchReason;
            return true;
          }
        }

        return false;
      });
      this.isLoading = false;
    },
    customFilter (item, queryText) {
        const desc = item.Description
        const skus = item.FmSku
        const refs = item.References
        const searchText = queryText.toUpperCase();
        const searchSku = searchText.replace(/[^\p{L}\p{N}]/gu, '');
        const ae = refs.some(o => o.Sku.replace(/[^\p{L}\p{N}]/gu, '').includes(searchSku));
        return desc.includes(searchText) ||
          skus.includes(searchText) || ae;
      },

    customDummyFilter (item, queryText) {
      return item && queryText;
    },
    async patchinvoiceItem(itemIndex) {
      let item = this.invoiceItems.at(itemIndex);
      item.InvoiceId = this.invoice.Id
      item.Profit = (item.Margin / (1 - item.Margin /100))
      item.Location = `${item.LocationPart}-${item.ShelfPosition}`;
      // console.log(item);

      if (item.Id) {
        const response = await this.$api.patch("/inventory/parts/checkin/"+item.Id, item)
          //console.log(response);
          item.Sku = response.data.Sku;
          item.Id = response.data.Id;
          item.Description = response.data.Description;

      } else {
        const response = await this.$api.post("/inventory/parts/checkin/", item)
          console.log(response);
        item.Id = response.data.Id;
        item.Description = response.data.Description;

      }
    },
    async processBarcode() {
      try {
        const barcodeInput = this.$refs.barcodeInput;
        const barcodeUrl = barcodeInput ? barcodeInput.$el.querySelector('input').value : '';
        const url = new URL(barcodeUrl);
        let invoice = null;
        let code = null;
        if (this.ecosHostnames.includes(url.hostname)) {
          code = url.pathname.substring(3); // Extract path without leading '/V/'
          invoice = {
            code: code,
            invoice_id: this.invoice.Id,
            service: 'ecos',
          };

        } else if (this.epsilonHostnames.includes(url.hostname)) {
         code = url.pathname.split('/').filter(segment=>segment.length > 0).pop(); // Extract path
         invoice = {
            code: code,
            invoice_id: this.invoice.Id,
            service: 'epsilon',
          };
        } else if (this.entersoftHostnames.includes(url.hostname)) {
          // Use URLSearchParams to extract the query parameter
          const params = new URLSearchParams(url.search);
          const authCode = params.get('id');
          invoice = {
            code: authCode,
            invoice_id: this.invoice.Id,
            service: 'entersoft',
          };
        } else if (this.pegasusHostnames.includes(url.hostname)) {
          // Use URLSearchParams to extract the query parameter
          const params = new URLSearchParams(url.search);
          const authCode = params.get('auth_code');
          invoice = {
            code: authCode,
            invoice_id: this.invoice.Id,
            service: 'pegasus',
          };
        } else {
          alert('Invalid domain');
        }

        // Use await for asynchronous operations
        const parseResponse = await this.$api.post('/inventory/parts/barcode-checkin', invoice);
        console.log(parseResponse.data);

        // Fetch the invoice details
        const response = await this.$api.get(`/suppliers/invoice/${this.$route.params.invoiceId}`, {
          cache: { maxAge: 30 * 1000 },
        });

        this.invoice = response.data;
        this.invoiceItems = []; // Clear existing items before pushing new ones

        let j = 1;
        for (const value of this.invoice.LineItems) {
          value.itemId = j;
          this.invoiceItems.push(value);
          j += 1;
        }
        this.ecosDialog = false;
      } catch (error) {
        alert('Invalid URL or network error');
      }
    },
    async checkPrintServerHealth() {
      try {
        const response = await this.$printerapi.get('/health', { crossDomain: true });
        /*
        axios.get("http://192.168.178.27:8000/health",{ crossDomain: true }).then(data=>{
            //Logic of your code
          this.isPrintServerHealthy = data.status === 200;
        });
        */
        this.isPrintServerHealthy = response.status === 200;
      } catch (error) {
        console.error('Print server health check failed:', error);
        this.isPrintServerHealthy = false;
      }
    },
    generateFilename(item) {
      const { Id, Manufacturer, FmSku } = item;
      return `Order-ID${Id}-${Manufacturer}-${FmSku}.png`;
    },
    async fetchLabels(items) {
      this.labelItems = [];
      this.showPrintDialog = true;
      for (const item of items) {
        try {
          const options = {
            method: 'GET',
            params: { label: this.labelType, filetype: "png" },
            url: '/inventory/generate-order-label/' + item.Id,
            responseType: "blob",
          };

          const response = await this.$api(options);
          const labelUrl = window.URL.createObjectURL(response.data);
          this.labelItems.push({ ...item, labelUrl,  quantity: 1});
        } catch (error) {
          console.error('Failed to fetch label:', error);
        }
      }
      await this.checkPrintServerHealth();
    },
    cancel() {
      this.showPrintDialog = false;
      this.labelItems.forEach(item => window.URL.revokeObjectURL(item.labelUrl));
      this.labelItems = [];
    },
    roundUpNearest05or1(num) {
      let nearest_five =  Math.ceil(num*100/5) * 5/100
      let nearest_ten =  Math.ceil(num) 
      // if the number is closer to next 5 or 10 return the nearest 5 or 10
      if (Math.abs(nearest_five - num) < Math.abs(nearest_ten-num)) return nearest_five
      // else return the nearest floor
      return nearest_ten
    },
    roundUpNearest5or10(num) {
      let nearest_five =  Math.ceil(num/5) * 5
      let nearest_ten =  Math.ceil(num/10) *10
      // if the number is closer to next 5 or 10 return the nearest 5 or 10
      if (Math.abs(nearest_five - num) < Math.abs(nearest_ten-num)) return nearest_five
      // else return the nearest floor
      return nearest_ten
    },
    roundSuggestedPrice() {
      // Replace with your actual base price getter
      const basePrice = this.editedItem.RetailPrice - (this.editedItem.RetailPrice*this.editedItem.Discount/100);
      if (!basePrice) return;

      // Target: nearest integer to current suggestedPrice
      const currentSuggested = this.suggestedPrice;
      let targetPrice = 0
      if (currentSuggested < 100) {
        targetPrice = this.roundUpNearest05or1(currentSuggested);
      } else {
        targetPrice = this.roundUpNearest5or10(currentSuggested);
      }

      // Calculate the required margin
      const margin = (1 - (basePrice/targetPrice)) * 100;

      // Update the margin (optionally round to 4 decimals)
      this.editedItem.Margin = Math.round(margin * 10000) / 10000;
    },
    ceilSuggestedPrice() {
      // Replace with your actual base price getter
      const basePrice = this.editedItem.RetailPrice - (this.editedItem.RetailPrice*this.editedItem.Discount/100);
      if (!basePrice) return;

      // Target: nearest integer to current suggestedPrice
      const currentSuggested = this.suggestedPrice;
      const targetPrice = Math.round(currentSuggested);

      // Calculate the required margin
      const margin = (1 - (basePrice/targetPrice)) * 100;

      // Update the margin (optionally round to 4 decimals)
      this.editedItem.Margin = Math.round(margin * 10000) / 10000;
    },

    divideRetailPriceByQty() {
      if (
        this.editedItem.Qty &&
        !isNaN(this.editedItem.Qty) &&
        this.editedItem.RetailPrice &&
        !isNaN(this.editedItem.RetailPrice)
      ) {
        const qty = parseFloat(this.editedItem.Qty);
        if (qty !== 0) {
          this.editedItem.RetailPrice = parseFloat(this.editedItem.RetailPrice) / qty;
        }
      }
    },
    customRepairFilter(item, queryText) {
      // Check for 'rid-<number>', 'RID-<number>', 'ριδ-<number>', or 'ΡΙΔ-<number>' pattern
      const ridMatch = queryText.match(/^(rid|ριδ)-(\d+)$/i);
      if (ridMatch) {
        const id = ridMatch[2];
        // Match by Id (assuming item.Id is a number or string)
        return String(item.Id) === id;
      }
      // Default filter: match by plate number or other fields as needed
      // You can customize this as needed
      const plate = item.Vehicle?.PlateNumber?.toString().toLowerCase() || '';
      const owner = item.Vehicle?.Owner?.Name?.toString().toLowerCase() || '';
      const id = item.Id?.toString().toLowerCase() || '';
      const query = queryText.toLowerCase();
      return ( 
        plate.includes(query) ||
        owner.includes(query) ||
        id.includes(query)
      );
    },
    async printLabel(item) {
      try {
        const response = await fetch(item.labelUrl);
        const blob = await response.blob();

        const formData = new FormData();
        formData.append('image', blob, this.generateFilename(item));

        await this.$printerapi.post('/print', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          params: {
            rotate: this.labelRotate,
            qty: item.quantity
          },
        });

        // this.cancel();
      } catch (error) {
        console.error('Failed to print label:', error);
      }
    },
    getPreorderStatus(status) {
      if (status == -2) return "Ζήτηση";
      if (status == -1) return "Παραγγελία";
      if (status == 0) return "Παραλαβή";
      if (status == 1) return "Ολοκληρωμένη";
      return "—";
    },
    preorderStatusColor(status) {
      if (status == -2) return 'orange darken-2';
      if (status == -1) return 'blue lighten-1';
      if (status == 0) return 'green darken-1';
      if (status == 1) return 'deep-purple darken-1';
      return 'grey';
    },
    async openPreorderCorrelate(item) {
      this.preorderSourceItem = item;
      const supplierId = this.invoice.Supplier.Id;
      if (!supplierId) {
        alert('Δεν υπάρχει προμηθευτής στο παραστατικό.');
        return;
      }
      this.preorderCorrelateDialog = true;
      this.preorderCorrelateLoading = true;
      this.preorderSelectedId = null;
      this.preorderCorrelated = [];
      this.preorderCandidates = [];
      try {
        // Already correlated preorders for this check-in item
        if (item.Id) {
          const corrResp = await this.$api.get('/inventory/preorders', { params: { checkin_id: item.Id, limit: 200 } });
          this.preorderCorrelated = corrResp.data || [];
        }
        // Available candidates for correlation (pending orders from the same supplier, optionally same part)
        const resp = await this.$api.get('/inventory/preorders', { params: { supplier_id: supplierId, status: -1, limit: 200 } });
        let candidates = resp.data || [];
        if (item.PartId) {
          candidates = candidates.filter(c => c.PartId === item.PartId);
        }
        // Exclude IDs already correlated
        const correlatedIds = new Set(this.preorderCorrelated.map(p => p.Id));
        this.preorderCandidates = candidates.filter(c => !correlatedIds.has(c.Id));
      } catch (e) {
        console.error('Αποτυχία φόρτωσης προπαραγγελιών:', e);
        this.preorderCandidates = [];
        this.preorderCorrelated = [];
      } finally {
        this.preorderCorrelateLoading = false;
      }
    },
    async savePreorderCorrelation() {
      const target = this.preorderCandidates.find(c => c.Id === this.preorderSelectedId);
      if (!target) return;
      const checkinId = this.preorderSourceItem && this.preorderSourceItem.Id;
      if (!checkinId) {
        alert('Το επιλεγμένο στοιχείο δεν έχει Id.');
        return;
      }
      try {
        await this.$api.patch(`/inventory/preorders/${target.Id}`, { CheckinId: checkinId, Status: 0});
        alert('Η συσχέτιση ολοκληρώθηκε.');
        this.preorderCorrelateDialog = false;
        this.preorderSelectedId = null;
        this.preorderSourceItem = null;
      } catch (e) {
        alert('Αποτυχία αποθήκευσης συσχέτισης.');
      }
    },
    },
  }
</script>

<style>
.row-odd {
  background-color: orange;
}
.row-even {
  background-color: "red";
}
</style>
